// extracted by mini-css-extract-plugin
module.exports = {"ciolfc2":"ciolfc2"};